module.exports = __webpack_public_path__ + "static/img/logo9.e8e563ac.png";